var render = function render(){var _vm=this,_c=_vm._self._c;return _c('person-select',{staticClass:"es-simple",model:{value:(_vm.author),callback:function ($$v) {_vm.author=$$v},expression:"author"}})
}
var staticRenderFns = []

export { render, staticRenderFns }